<template>
  <tbody>
    <tr
      v-for="(row, i) in data"
      :id="`row-${i}`"
      :key="i"
      @click.stop="onClickRow(row)"
      @mouseup.stop
      :class="{ 'selected-row': isRowSelected(row) }"
    >
      <td v-if="isSelectable">
        <div class="td-content">
          <div
            class="checkbox checkbox-custom checkbox-primary"
            @click.stop="onToggleRowSelection(row)"
          >
            <input
              :disabled="isRowDisabled(row)"
              :checked="isRowSelected(row)"
              type="checkbox"
            />
            <label />
          </div>
        </div>
      </td>

      <td
        v-for="(header, j) in headers"
        :key="j"
      >
        <component
          :is="getRowComponent(header)"
          :data="row"
          :header="header"
          :position="i"
          :store-name="storeName"
        />
      </td>
    </tr>

    <tr v-if="data.length == 0">
      <td
        :colspan="
          headers.filter((h) => !h.hidden).length + (isSelectable ? 1 : 0)
        "
        class="empty-table"
      >
       {{ customMessage }}
      </td>
    </tr>
  </tbody>
</template>

<script>
import WTSingleRowValue from "./WTSingleRowValue.vue";
import WTButtonsRow from "./WTButtonsRow.vue";
import WTRawHtmlRow from "./WTRawHtmlRow.vue";

export default {
  name: "wt-body",
  components: {
    WTSingleRowValue,
    WTButtonsRow,
    WTRawHtmlRow,
  },
  props: {
    data: {
      type: Array,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
    storeName: {
      type: String,
    },
    headers: { type: Array },
    checkboxValidationCallback: { type: Function },
    isSingleSelectionMode: { type: Boolean, default: false },
    clickToSelect: { type: Boolean, default: false },
    customMessage: {
      type: String,
      default: "No se encontraron registros",
    }
  },
  methods: {
    getRowComponent(header) {
      // CHECK HEADER COMPONENT PROP
      if (header.component) {
        return header.component;
      }

      // CHECK HEDAER BUTTONS PROP
      if (header.buttons) {
        return "WTButtonsRow";
      }

      // CHECK FOR FORMATTER PROP
      if (header.formatter) {
        return "WTRawHtmlRow";
      }

      return "WTSingleRowValue";
    },
    isRowSelected(row) {
      return (
        this.state.selection.findIndex(
          (item) => JSON.stringify(item) == JSON.stringify(row)
        ) > -1
      );
    },
    isRowDisabled(row) {
      if (this.checkboxValidationCallback) {
        return this.checkboxValidationCallback(row);
      }

      return false;
    },
    onToggleRowSelection(row) {
      this.dispatch("selectRow", {
        row,
        isSingleSelection: this.isSingleSelectionMode,
      });
    },
    onClickRow(row) {
      if (this.clickToSelect && !this.isRowDisabled(row)) {
        this.onToggleRowSelection(row);
      }

      this.$emit("onRowClicked", row);
    },
    dispatch(action, payload) {
      this.$store.dispatch(`${this.storeAddress()}/${action}`, payload);
    },
    storeAddress() {
      return this.storeName.replace(/\./g, "/") + "/table";
    },
  },
  computed: {
    state() {
      return this.$propertyByString(this.$store.state, this.storeName).table;
    },
  },
};
</script>
